import { render, staticRenderFns } from "./productLogList.vue?vue&type=template&id=653be6eb"
import script from "./productLogList.vue?vue&type=script&lang=js"
export * from "./productLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports